import axiosServices from './request';

const ResourceApi = axiosServices('resourcecenter/v1.0');

export default {
  /** 获取作品信息 */
  getPro4AdviserByType: ResourceApi('get', 'product/getPro4AdviserByType'),
  /** 获取作品分类 */
  findProductTypes: ResourceApi('get', 'productType/findProductTypes'),
};